import moment from "moment";
import { setConfirmLeavePage } from "../store/reducer/page.reducer";
import _ from "lodash";
import { useSelector } from "react-redux";

export const onChanged = (dispatch, payload) => {
  dispatch(setConfirmLeavePage(payload));
};

export const makeListDDL = (list) => {
  const newList = list.map((item) => {
    return { label: item.value, value: item.id };
  });

  return newList;
};

export const makeDropdown = (list) => {
  const newList = list.map((item) => {
    return { label: item.name, value: item.id };
  });

  return newList;
};

export const makeDropdownPostalCode = (list) => {
  const newList = list.map((item) => {
    return { label: item.code, value: item.id };
  });

  return newList;
};

export const validateSubmit = (error) => {
  for (const key in error) {
    if (Object.hasOwnProperty.call(error, key)) {
      if (error[key]) return false;
    }
  }
  return true;
};

export const convertToArrData = (data) => {
  if (data !== undefined && data.includes(",")) {
    const newData = data.split(",");
    const result = newData.map((item) => ({ data: item }));

    return result;
  } else if (data !== undefined && !data.includes(",")) {
    const dataArr = [{ data }];

    return dataArr;
  } else {
    return [];
  }
};

export const licenseType = (data) => {
  if (data === 1) {
    return "SIM A";
  } else if (data === 2) {
    return "SIM B1";
  } else if (data === 3) {
    return "SIM B2";
  } else if (data === 4) {
    return "SIM C";
  } else if (data === 5) {
    return "SIM D";
  } else {
    return "-";
  }
};

export const convertDate = (date) => {
  const formattedDate = moment(date).format("DD-MMM-YYYY");

  return formattedDate;
};

export const makeDropdownDriver = (list) => {
  const newList = list.map((item) => {
    return {
      value: `${item.driver_name} - ${item.vehicle_type} - ${item.vehicle_no}`,
      id: item.driver_id,
    };
  });

  return newList;
};

export const getNameImage = (photos) => {
  const photoSplitted = photos.split("/");
  const namePhotos = photoSplitted[photoSplitted.length - 1];

  return namePhotos;
};

export const splitTime = (datas) => {
  const timeSplitted = datas.split(":");

  return timeSplitted;
};

export const convertToArray = (data) => {
  const dataSplitted = data.split(",");

  const newList = dataSplitted.map((item, index) => {
    return { label: item, value: index };
  });

  return newList;
};

export const getArrId = (data) => {
  const dataSplitted = data.split(",");

  const newList = dataSplitted.map((item, index) => {
    return { label: item, value: index };
  });

  const arrId = newList.map((item) => item.value);

  return arrId;
};

export const convertTimestamp = (timestamp, isSpecific) => {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const monthNumbers = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];

  // Extract components from the timestamp string
  const year = timestamp?.substring(0, 4);
  const month = timestamp?.substring(5, 7) - 1; // Months in JavaScript are 0-indexed
  const day = timestamp?.substring(8, 10);

  let dateFormat = new Date(year, month, day);

  if (isSpecific) {
    return `${dateFormat.getDate()}-${
      monthNames[dateFormat.getMonth()]
    }-${dateFormat.getFullYear()}`;
  } else {
    return `${dateFormat.getDate()}/${
      monthNumbers[dateFormat.getMonth()]
    }/${dateFormat.getFullYear()}`;
  }
};

export const convertToTime = (timestamp) => {
  // let time = new Date(timestamp);
  return moment(timestamp).utc().format("HH:mm");
};

export const convertToRibuan = (data) => {
  if (Number(data) > 999) {
    let hasil = (Number(data) / 1000).toLocaleString("en-US", {
      minimumFractionDigits: 3,
    });
    return hasil;
  } else {
    return data;
  }
};

export const onChangeSearch = (event, page, limit, setSearchValue) => {
  const { value } = event.target;
  const resetPage = 1;
  clearTimeout(this.inputTimer);
  let filterSearch = value && `${value}`;
  // this.setState({
  //   searchValue: value,
  // });
  setSearchValue(value);
  let filter = [filterSearch];
  filter = filter.filter(
    (item) => item !== undefined && item !== null && item !== ""
  );
  filter = filter.length !== 0 ? filter.join(", ") : undefined;
  const resetFilter = filter;
  if (value.length >= 3) {
    this.setState(
      { loading: true, listTitle: [], filter, page: resetPage },
      () => {
        this.inputTimer = setTimeout(
          () => this.getListTitle(page, limit, filter),
          256
        );
      }
    );
  } else if (!value) {
    this.setState(
      {
        loading: true,
        listTitle: [],
        filter: resetFilter,
        page: resetPage,
      },
      () => {
        setTimeout(
          () =>
            this.getListTitle(
              this.state.page,
              this.state.limit,
              this.state.filter
            ),
          256
        );
      }
    );
  }
};

export const permissionButton = (permission, action, menu, parent) => {
  const matchingKeys = [];
  for (let key in permission) {
    if (key.includes(menu)) {
      matchingKeys.push(key);
    }
  }
  if (matchingKeys.length > 0) {
    if (permission?.[matchingKeys[0]]?.includes(action)) {
      return true;
    } else {
      return false;
    }
  } else if (permission.hasOwnProperty(parent)) {
    if (permission?.[parent]?.includes(action)) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};
